module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-1 pl-2",
    staticStyle: {
      "width": "170px",
      "flex": "none"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Nhập tên tàu"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.loadData()
      }
    },
    model: {
      value: (_vm.nameOfShip),
      callback: function($$v) {
        _vm.nameOfShip = $$v
      },
      expression: "nameOfShip"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0 mr-2 py-0 my-0",
    staticStyle: {
      "text-transform": "none",
      "color": "#1d52e8"
    },
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.loadData()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "17"
    }
  }, [_vm._v("search")]), _vm._v(" Tìm kiếm")], 1)], 1), _vm._v(" "), (_vm.loadingTableAnchorage) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _c('vue-good-table', {
    ref: "myCustomTable",
    attrs: {
      "columns": _vm.headers,
      "rows": _vm.itemsDsTauAll,
      "groupOptions": {
        enabled: true,
        expand: true
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-tra-cuu"
  }, [_c('span', {
    staticClass: "ml-3"
  }, [_vm._v("Vị trí tàu tại cảng")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59b9e67a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViTriTauTaiCang.vue
// module id = 721
// module chunks = 1